import React, { useMemo, useCallback } from 'react'
import { type SourceType, isEmail } from '../../requests/sources'

type Props = {
  sources: SourceType[]
  filteredSources: SourceType[]
  setFilteredSources: (sources: SourceType[]) => void
}
export const SelectFilteredSources: React.FC<Props> = ({
  sources,
  filteredSources,
  setFilteredSources
}) => {
  const options = useMemo(() => {
    if (!sources.length) {
      return []
    }

    const filteredSourceIds = filteredSources.map(src => src._id)

    const optionsToBe = sources.map((src) => {
      return {
        value: src._id,
        label: isEmail(src) ? src.subject : src.title,
        checked: filteredSourceIds.includes(src._id)
      }
    })

    optionsToBe.unshift({
      value: 'all',
      label: 'See all sources',
      checked: filteredSources.length === sources.length
    })

    return optionsToBe
  }, [sources, filteredSources])

  const title = useMemo(() => {
    if (sources.length === 0) {
      return `Filter Sources ( No Sources Available to Filter )`
    }

    if (filteredSources.length === 0) {
      return `Filter Sources ( No Sources Selected )`
    }

    if (sources.length === filteredSources.length) {
      return `Filter Sources ( Viewing All ${sources.length} Total )`
    }
    return `Filter Sources ( Viewing ${filteredSources.length} / ${sources.length} Total )`
  }, [sources, filteredSources])

  const handleSourceChange = useCallback((
    e: React.ChangeEvent<HTMLInputElement>,
    option: { value: string, label: string }
  ) => {
    if (option.value === 'all') {
      if (filteredSources.length === sources.length) {
        return setFilteredSources([])
      }

      return setFilteredSources(sources)
    }

    if (e.target.checked) {
      return setFilteredSources([
        ...filteredSources,
        sources.find(src => src._id === option.value)!
      ])
    }

    return setFilteredSources(
      filteredSources.filter(src => src._id !== option.value)
    )
  }, [setFilteredSources, sources, filteredSources])

  return (
    <label htmlFor="filteredEmails">
      { title }
      <div className="filter-box">
        {
          options.map(option => (
            <label htmlFor={option.value} key={option.value}>
              <input
                key={option.value}
                type="checkbox"
                value={option.value}
                checked={option.checked}
                name={option.value}
                id={option.value}
                onChange={(e) => handleSourceChange(e, option)}
              />
              <span className="email-subject">{option.label}</span>
            </label>
          ))
        }
      </div>
    </label>
  )
}
